import { useEffect } from 'react';
import { useAuth } from '@feature/auth/hooks/useAuth';
import { configureAuthInterceptor } from '@shared/services/api/interceptors/auth.interceptor';

export const AuthInterceptorProvider = ({ children }: { children: React.ReactNode }) => {
  const { getToken } = useAuth();

  useEffect(() => {
    if (getToken) {
      const cleanup = configureAuthInterceptor(getToken);
      return () => {
        cleanup?.();
      };
    }
  }, [getToken]);

  return <>{children}</>;
}; 